import { Routes } from '@angular/router';

import { LoginComponent } from './auth/login/login.component';
import { PasskeyComponent } from './auth/passkey/passkey.component';
import { canAuthenticate, canEnterPassword, isAuthenticated } from './core/guards/auth.guard';
import { principalResolve } from './core/resolves/principal.resolve';

export const APPLICATION_ROUTES: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [canAuthenticate]
  },
  {
    path: 'passkey',
    component: PasskeyComponent,
    canActivate: [canEnterPassword]
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home-routes').then((m) => m.HOME_ROUTES),
    canActivate: [isAuthenticated],
    resolve: [principalResolve]
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '404',
    loadComponent: () => import('./pages/not-found/not-found.component').then((m) => m.NotFoundComponent)
  },
  { path: '**', redirectTo: '/404' }
];
